import { render } from "./OneProductTitleBodyLoop.vue?vue&type=template&id=45c886dc&scoped=true"
import script from "./OneProductTitleBodyLoop.vue?vue&type=script&lang=js"
export * from "./OneProductTitleBodyLoop.vue?vue&type=script&lang=js"

import "./OneProductTitleBodyLoop.vue?vue&type=style&index=0&id=45c886dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c886dc"]])

export default __exports__